module.exports = __webpack_public_path__ + "img/biaoqian_huagongchang.c2b0d250.png";